<template>
  <v-container class="survey-appearance pl-0 pt-0 ">
    <page-title title="Appearance"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <AppearanceWidgetTwoColumn :campaign="campaign" 
    :showAnimationSettings="true"
    :showPoweredBySettings="showPoweredBySettings" @change="save"></AppearanceWidgetTwoColumn>
  </v-container>
</template>

<script>
import debounce from 'lodash/debounce'
import AppearanceWidgetTwoColumn from '@/components/survey/AppearanceWidgetTwoColumn.vue'
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
export default {
  components: {
    AppearanceWidgetTwoColumn,
    Tabs
  },
  name: 'AppearanceView',
  data: function() {
    let showPoweredBySettings = false
    let poweredByEnabled= false
    if(this.$store.getters['user/currentCampaign'].enabled_features && 
      Object.keys(this.$store.getters['user/currentCampaign'].enabled_features).indexOf('POWERED_BY') > -1) {
      showPoweredBySettings = true
      poweredByEnabled = this.$store.getters['user/currentCampaign'].enabled_features.POWERED_BY
    }

    return {
      campaign: {
        brandName: this.$store.getters['user/currentCampaign'].brand_name,
        brandColor: this.$store.getters['user/currentCampaign'].primary_color,
        language: this.$store.getters['user/currentCampaign'].primary_lang,
        widgetPosition: this.$store.getters['user/currentCampaign'].options
          .widget_settings.position,
        widgetAnimations: this.$store.getters['user/currentCampaign'].options
          .widget_settings.animation_enabled,
        poweredBy: poweredByEnabled,
        buttonPosition: this.$store.getters['user/currentCampaign'].options
          .button_settings.position,
        buttonEnabled: this.$store.getters['user/currentCampaign'].options
          .button_settings.enabled,
        buttonLabel: this.$store.getters['user/currentCampaign'].options
          .button_settings.label,
        previewItem: "FEEDBACK_WIDGET"
      },
      showPoweredBySettings: showPoweredBySettings
    }
  },
  computed: {
    tabSettings: function() {
      const tabs = []
        tabs.push({
          id: routes.SURVEY_APPEARANCE,
          label: 'Survey'
        })
      return {
        preselected: null,
        tabs: tabs
      }
    }
  },
  methods: {
    save: debounce(function(data) {
      const vm = this
      const form = {
        brand_name: data.brandName,
        primary_color: data.brandColor,
        primary_lang: data.language,
        widget_position: data.widgetPosition,
        animation_enabled: data.widgetAnimations,
        enabled_features: {POWERED_BY: data.poweredBy},
        button_label: data.buttonLabel,
        button_position: data.buttonPosition,
        button_enabled: data.buttonEnabled
      }
      const struct = {
        campaignId: this.$store.getters['user/currentCampaign'].id,
        form: form
      }
      return this.$store
        .dispatch('campaign/updateAppearance', struct)
        .then(function(res) {})
    }, 500)
  }
}
</script>

<style></style>
